import React from "react";
import { useAuthInit } from "../../hooks/use-auth-init";
import { LandingBackToTopButton } from "./components/back-to-top-button";
import { LandingBenefitsSection } from "./components/benefits-section";
import { LandingFaqSection } from "./components/faq-section";
import { LandingFooter } from "./components/footer";
import { LandingHowToBuySection } from "./components/how-to-buy-section";
import { LandingIntro } from "./components/intro";
import { LandingQuotationPopup } from "./components/quotation-popup";
import { LandingQuoteButton } from "./components/quote-button";
import { LandingWorkersPayRollModal } from "./components/workers-payroll-modal";
import { useRecaptchaLoad } from "./hooks/use-recaptcha-load";
import "./landing.scss";
import { LandingProvider } from "./providers/landing-provider";

const Landing = () => {
    useRecaptchaLoad();
    useAuthInit();
    return (
        <LandingProvider>
            <div className="landing" data-testid="landing">
                <LandingIntro />
                <LandingQuoteButton />
                <LandingBenefitsSection />
                <LandingHowToBuySection />
                <LandingFaqSection />
                <LandingBackToTopButton />
                <LandingFooter />
                <LandingQuotationPopup />
                <LandingWorkersPayRollModal />
            </div>
        </LandingProvider>
    );
};

export default Landing;
